import Lang from 'ln/lang/Lang';
import {renderer} from 'ln/view/Renderer';
import {scan} from 'ln/view/View';
import {setup, SetupConfig} from 'ln/setup/Setup';
import Request from 'ln/request/Request';
import { suspendData, ScormSingleton as scorm, ISuspendData } from './ScormSingleton';

import {Asset} from './asset';
import './components/register';

export function load(dataUri: string) {
    Request.get(dataUri).load().then(init);
}

export function init(config: SetupConfig) {

    var data:ISuspendData;
    if( scorm.api.suspendData || scorm.api.suspendData != '' ){
        //console.log( scorm.api.suspendData );
        suspendData.data = JSON.parse( scorm.api.suspendData );
    }

    setup.init(config);
    renderer.context.setup = setup;

    renderer.context.transparentPixelPath = function() {
		// Returns a single transparent pixel as a data URL. This can be used as a fallback
		// so that a missing image won't cause rendering of other elements to fail:
		return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
    }

    renderer.context.assetConversionPath = ( fileName:string, urloptions:{ time:number }, preset: string = 'chapter-preview', outputExtension: string = 'jpg' ) => {
		if (!config.data['assetConversionAvailable']) {
			// If asset conversion is not available, fall back to a single transparent pixel:
			return renderer.context.transparentPixelPath();
		}
		else {

            const time = Number(urloptions.time || 0);
            const hours = Math.floor(time / 3600);
            const minutes = Math.floor((time - hours * 3600) / 60);
            const seconds = Math.floor(time - hours * 3600 - minutes * 60);
            const milliseconds = time.toFixed(3).split('.')[1] ;

            let formattedTime = `${hours}:${minutes}:${seconds}.${milliseconds}`;

            let parameters = {
                options:{ time: formattedTime },
                preset:preset,
                outputExtension: outputExtension
            }
            // Build a query string-like options string:
            const optionParts = [];

			for (const name in parameters.options) {
				if (parameters.options.hasOwnProperty(name)) {
					optionParts.push(encodeURIComponent(name) + '=' + encodeURIComponent(parameters.options[name]));
				}
			}
			const options = optionParts.join('&');

			// Substitute all parameters in the URL template provided by the backend:
			return decodeURIComponent(setup.route('assetConversion', { fileName, ...parameters, options }).url());
		}
	}



    renderer.context.assetUri = (path:string) => setup.route( 'image', { file_name: path } ).url();
    renderer.context.imageUri = (asset: Asset, preset: string = 'large', ext: string = 'png') => setup.route('asset', { 'file_name': asset.file_name, preset, ext }).url();
    renderer.context.videoUri = (asset: Asset, preset: string = 'original', ext: string = 'mp4') => setup.route('asset', { 'file_name': asset.file_name, preset, ext }).url();
    renderer.context.downloadPath = ( text:string ) => {
        return text.replace( /app:\/\/download\/([^"]+)/gm, function( args, file_name ){
            return setup.route( 'download', { file_name:file_name }).url();
        });
    }

    Lang.add(setup.data('lang'));
    renderer.context.trans = function(key: string, opts?: { data?: any, condition?: number }) {
        return Lang.translate(key, opts);
    };

    scan(document.body);
}
